<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Linaware Logo"
          class="shrink mr-2"
          contain
          src="@/assets/images/logo_lw.png"
          transition="scale-transition"
          width="40"
        />

        <h1>Linaware</h1>
      </div>

      <v-spacer></v-spacer>
      <div>v1.1.0</div>
    </v-app-bar>

    <v-main>
      <HelloWorld/>
    </v-main>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>
